export default __webpack_public_path__ + "static/media/dragIcon.b21d2d3c.svg";